import { render, staticRenderFns } from "./PlayerMonitorSettings.vue?vue&type=template&id=2efda9fc&scoped=true&"
import script from "./PlayerMonitorSettings.vue?vue&type=script&lang=ts&"
export * from "./PlayerMonitorSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerMonitorSettings.vue?vue&type=style&index=0&id=2efda9fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efda9fc",
  null
  
)

export default component.exports